import React from "react";
import {useEventTypeLabels} from "./useEventTypeLabels";

const EventTypesCell = ({data, renderKey}) => {
  const getLabels = useEventTypeLabels();
  const labels = getLabels(data?.[renderKey]);

  return <span>{labels.length ? labels.join(", ") : "-"}</span>;
};

export default EventTypesCell;
